<style scoped>

</style>
<template>
  <v-menu
    ref="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-textarea
        :value="display&&display(tree_selected)"
        :label="label"
        :placeholder="placeholder"
        :required="required"
        :rules="rules"
        :rows="rows"
        :prepend-icon="prependIcon"
        readonly
        v-bind="attrs"
        v-on="on"
      />
    </template>
    <div style="max-height:500px">
      <v-treeview
        v-model="tree_selected"
        style="background-color:#FFFFFF"
        selected-color="#005caf"
        :items="items"
        :item-key="itemKey"
        :item-text="itemText"
        selectable
        return-object
        open-all
      />
    </div>
  </v-menu>
</template>
<script>
  export default {
    props: {
      value: {
        type: Array,
        default: () => []
      },
      label: {
        type: String,
        default: '选择项目'
      },
      placeholder: {
        type: String,
        default: '点击选择'
      },
      locale: {
        type: String,
        default: 'zh'
      },
      required: {
        type: Boolean,
      },
      rules: {
        type: Array,
      },
      type: {
        type: String,
        default: () => undefined
      },
      itemKey: {
        type: String,
        default: () => 'id'
      },
      itemText: {
        type: String,
      },
      display: {
        type: Function,
      },
      prependIcon: {
        type: String,
        default: () => 'mdi-form-select'
      },
      items: {
        type: Array
      },
      rows: {
        type: [String, Number],
        default: () => '2'
      }
    },
    data() {
      return {
        menu: false,
        tree_selected: this.value,
      }
    },
    computed: {
      /*    valueHash() {
        return recursionToHash(this.items, this.value_key)
      } */
    },
    watch: {
      tree_selected(val) {
        this.$emit('input', val)
      },
      value(val) {
        this.tree_selected = val
      }
    },
    methods: {
    },
  }
</script>
